import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import tabbedForms from '../../../css/components/forms/tabbed-forms/tabbedForms.css';
import ExtendedLoginForm from '../ExtendedLogin';
import { useTranslation } from 'react-i18next';
import { OneLPSsdkParamsContext } from '../../../onelps-sdk-params-context';

function TabbedForms({ children }) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const TABBED_FORMS = {
		REG: 'reg',
		LOGIN: 'login',
	};
	const [selectedForm, setSelectedForm] = useState(onelpsParams.abTestFeatureFlags?.['CONV-12294-slightlyAdaptedHarbourBundle'] ? TABBED_FORMS.REG : TABBED_FORMS.LOGIN);
	const { t } = useTranslation('translation');

	return(
		<div className={tabbedForms.tabbed}>
			<>
				<input
					type="radio"
					id="tab1"
					name="css-tabs"
					checked={selectedForm === TABBED_FORMS.REG}
					onChange={() => setSelectedForm(TABBED_FORMS.REG)}
				/>
				<input
					type="radio"
					id="tab2"
					name="css-tabs"
					checked={selectedForm === TABBED_FORMS.LOGIN}
					onChange={() => setSelectedForm(TABBED_FORMS.LOGIN)}
				/>
			
				<ul className={tabbedForms.tabs}>
					<li className={tabbedForms.tab}>
						<label htmlFor="tab1">
							{t('tabbedForms.register')}
						</label>
					</li>
					<li className={tabbedForms.tab}>
						<label htmlFor="tab2">
							{t('tabbedForms.login')}
						</label>
					</li>
				</ul>		
			</>
			<div className={tabbedForms['tab-content']}>
				{children}
			</div>
			<div className={tabbedForms['tab-content']}>
				<ExtendedLoginForm
					isTabbed
					formWrapperClassName="regFormWrapper"
					showRememberMe
					showForgotPassword
				/>
			</div>
			
		</div>
	);
}

TabbedForms.propTypes = {
	children: PropTypes.node.isRequired,
};

export default TabbedForms;